import type { HttpGetWithMeta } from '@/shared/infra/http'
import type { DogPhoto } from '@/shared/domain'
import type { ListDogPhotos } from '@/modules/gallery/use-cases'
import { buildGalleryQueryString } from './build-gallery-query-string'

export class SupabaseListDogPhotosRepository {
  constructor(private readonly http: HttpGetWithMeta) {}

  execute: ListDogPhotos = async (params) => {
    const { data, meta } = await this.http.getWithMeta<{ photos: DogPhoto[] }>({
      url: `/hunt-photos/dog-photos${buildGalleryQueryString(params)}`,
    })
    return { photos: data.photos, total: (meta?.total as number) ?? data.photos.length }
  }
}
